import type { CommandResult, RcuConfig } from '../model';
import { ok } from '../result';

/**
 * Wraps a successful command result, stamping `updatedAt` from the injected
 * clock. Every command ends here, so no command can forget to touch the config.
 */
export const changedBy = <T>(config: RcuConfig, value: T, now: string): CommandResult<T> =>
  ok({ config: { ...config, updatedAt: now }, value });
